<template lang="pug">
  .wrap
    CompanySidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': this.headerFixedSp }")
          CompanySortArea(
            @searchOrderBy="searchOrderBy"
            @toggleSidebar="toggleSidebar"
          )
        Pagination(
          :pagination="pagination"
          :listUpside="true"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage")
        .job-list-body
          CompanyColumnSortModal
          table.row-list
            CompanyTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck"
              :leadManagementShareButton="user.lead_management"
            )
            CompanyTableRow(
              v-for="(v, i) in index",
              :company="v",
              :index="i",
              :key="v.id",
              :updateMarkForIndex="true",
              :checkedIds="pageCheckedIds",
              :exclusionCompanyName="exclusionCompanyName",
              @check="toggleCheck",
              @update="reloadOrSkip"
              @hideCompany="hideCompany"
              :leadManagementShareButton="user.lead_management"
            )
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage")
      CompanyMenu(
        @remove="reload"
        :leadManagementShareButton="user.lead_management"
      )
    AddAccountModal(:update="updateIndex")
    Footer
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { ErrorMessages, perPages } from '../../constants'
  import CompanyColumnSortModal from '../parts/CompanyColumnSortModal'
  import CompanyMenu from '../parts/CompanyMenu'
  import CompanySidebar from '../parts/CompanySidebar'
  import CompanySortArea from '../parts/CompanySortArea'
  import CompanyTableHeader from '../parts/CompanyTableHeader'
  import CompanyTableRow from '../parts/CompanyTableRow'
  import Footer from '../parts/Footer'
  import Pagination from '../parts/Pagination'
  import AddAccountModal from '../parts/AddAccountModal'

  export default {
    components: {
      CompanyColumnSortModal,
      CompanyMenu,
      CompanySidebar,
      CompanySortArea,
      CompanyTableHeader,
      CompanyTableRow,
      Footer,
      Pagination,
      AddAccountModal,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_COMPANY)
      }
      if (!perPages.map(p => p.code).includes(query.perPage)) {
        throw new Error(ErrorMessages.INVALID_PER_PAGE_SEARCH_COMPANY)
      }

      await store.dispatch('company/fetchIndex', query)
    },
    data () {
      return {
        headerFixedSp: false,
        openSidebar: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      this.fetchExclusionCompanyName()
    },
    computed: {
      ...mapGetters('company', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapState({
        user: state => state.user.detail,
        meta: state => state.route.meta,
        pagination: state => state.company.pagination,
        index: state => state.company.index,
        pageCheckedIds: state => state.company.pageCheckedIds,
        exclusionCompanyName: state => state.exclusionCompanyName.enable,
      }),
    },
    methods: {
      ...mapActions('company', ['toggleCheck', 'togglePageCheck', 'hideCompany']),
      async searchOrderBy (target) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order: target,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      async selectPage (page) {
        this.reload({ page })
      },
      async selectPerPage (perPage) {
        this.updateCompaniesPerPage(perPage)
        this.reload({ perPage, page: '1' })
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      async updateCompaniesPerPage (companiesPerPage) {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/updateCompaniesPerPage', { companiesPerPage })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async updateIndex (ids) {
        this.$store.commit('company/updateIndexForAccount', ids)
        this.$store.commit('company/uncheckAll')
      },
      async fetchExclusionCompanyName () {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('exclusionCompanyName/fetch')
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchCompany.vue